// Terms of Service - Arabic version (RTL)

export const termsContentAR = {
  sections: [
    { id: 'general', title: '1. الأحكام العامة' },
    { id: 'services', title: '2. موضوع الخدمات وقبولها' },
    { id: 'reporting', title: '3. التقييم والتقارير والنتائج' },
    { id: 'payment', title: '4. الدفع والغرامات' },
    { id: 'obligations', title: '5. حقوق والتزامات الأطراف' },
    { id: 'ip', title: '6. الملكية الفكرية' },
    { id: 'confidentiality', title: '7. السرية ومعالجة البيانات' },
    { id: 'liability', title: '8. المدفوعات والاسترداد والمسؤولية' },
    { id: 'termination', title: '9. مدة السريان والإنهاء والعواقب' },
    { id: 'force-majeure', title: '10. القوة القاهرة' },
    { id: 'disputes', title: '11. حل النزاعات والقانون المطبق' },
    { id: 'other', title: '12. أحكام أخرى' }
  ],
  
  general: {
    title: '1. الأحكام العامة',
    content: [
      { num: '1.1', text: 'تنظم هذه الشروط تقديم الخدمات من قبل Polyus Plus OÜ (المشار إليها فيما يلي بـ "مقدم الخدمة") والعميل (المشار إليه فيما يلي بـ "العميل") وفقًا للعقد المبرم أو الطلب أو الفاتورة المدفوعة (المشار إليها فيما يلي بـ "العقد").' },
      { num: '1.2', text: 'بدفع الفاتورة أو توقيع العقد، يؤكد العميل أنه قد قرأ وفهم وقبل هذه الشروط بالكامل.' },
      { num: '1.3', text: 'يقدم مقدم الخدمة خدمات استشارية وأتمتة وذكاء اصطناعي وذكاء أعمال وخدمات أخرى ذات صلة وفقًا للوصف على الموقع الإلكتروني و/أو العقد. يتعهد العميل بدفع ثمن الخدمات وتوفير المعلومات والوصول اللازم.' },
      { num: '1.4', text: 'تنطبق هذه الشروط حصريًا على المعاملات بين الكيانات القانونية و/أو أصحاب المشاريع الفردية (B2B). لا ينطبق قانون حماية المستهلك (Tarbijakaitseseadus).' },
      { num: '1.5', text: 'في حالة وجود تناقضات بين نسخ اللغات، يكون للنسخة الإستونية الأولوية.' }
    ]
  },
  
  services: {
    title: '2. موضوع الخدمات وقبولها',
    content: [
      { num: '2.1', text: 'يقدم مقدم الخدمة الخدمات وفقًا للباقة المختارة (على سبيل المثال، INSIGHT، GROWTH ENGINE، AI TRANSFORM، PROJECT+). يتعهد العميل بدفع ثمن الخدمات والتعاون (توفير البيانات والوصول والموافقات).' },
      { num: '2.2', text: 'يتم تحديد النطاق والمواعيد النهائية في العقد. في حالة التأخير في توفير المعلومات أو الوصول، يحق لمقدم الخدمة تغيير المواعيد النهائية.' },
      { num: '2.3', text: 'يحق لمقدم الخدمة تغيير طرق ووسائل تقديم الخدمات وفقًا لتقديره، إذا لم يؤدي ذلك إلى تدهور النتيجة المتفق عليها.' },
      { num: '2.4', text: 'القبول: يفحص العميل النتائج المسلمة في غضون 3 (ثلاثة) أيام عمل ويرسل الملاحظات الكتابية عبر البريد الإلكتروني. في حالة عدم وجودها، تعتبر النتائج مقبولة افتراضيًا. يعادل الاستخدام الفعلي للنتائج من قبل العميل قبولها.', highlight: true },
      { num: '2.5', text: 'طلب التغيير: يتم توثيق أي تغييرات في المتطلبات أو النطاق كتابيًا (عبر البريد الإلكتروني)، وتدفع بشكل منفصل، وتستلزم تعديلًا مقابلًا للمواعيد النهائية.', highlight: true },
      { num: '2.6', text: 'يحق لمقدم الخدمة تعديل المواعيد النهائية والتكاليف إذا أدت التأخيرات أو عدم اكتمال البيانات من جانب العميل إلى توقف أو نفقات إضافية.' }
    ]
  },
  
  reporting: {
    title: '3. التقييم والتقارير والنتائج',
    content: [
      { num: '3.1', text: 'يسجل مقدم الخدمة مؤشرات الأداء الرئيسية (KPI) وبالاتفاق مقاييس العائد على الاستثمار (ROI).' },
      { num: '3.2', text: 'يقر العميل بأن النتيجة تعتمد على البيانات الأولية والقرارات والإجراءات التي يتخذها العميل نفسه. لا يضمن مقدم الخدمة نتيجة تجارية محددة.' },
      { num: '3.3', text: 'لا يتحمل مقدم الخدمة المسؤولية عن خسارة الأرباح أو البيانات أو السمعة أو أي خسائر غير مباشرة.' },
      { num: '3.4', text: 'جميع التوقعات والاستنتاجات التحليلية والحسابات تقديرية ولا تشكل ضمانًا للنتائج.' }
    ]
  },
  
  payment: {
    title: '4. الدفع والغرامات',
    content: [
      { num: '4.1', text: 'تشير تكلفة الخدمات على الموقع الإلكتروني و/أو في العقد.' },
      { num: '4.2', text: 'يُسمح بالدفع المسبق الجزئي إذا كان محددًا في العقد.' },
      { num: '4.3', text: 'لكل يوم تأخير في الدفع، تُفرض غرامة قدرها 0.05٪ من المبلغ غير المدفوع حتى يوم الدفع الكامل شاملاً.', penalty: '0.05 %' },
      { num: '4.4', text: 'يحق لمقدم الخدمة تعليق تقديم الخدمات إذا تأخر الدفع لأكثر من 5 أيام تقويمية.' },
      { num: '4.5', text: 'لا يحق للعميل حجب المدفوعات أو إجراء مقاصة دون موافقة كتابية من مقدم الخدمة.' },
      { num: '4.6', text: 'يحق لمقدم الخدمة، وفقًا لتقديره، فرض رسوم على إعادة تشغيل الأعمال وإعادة توزيع الموارد، بعد إخطار العميل مسبقًا.' },
      { num: '4.7', text: 'جميع الأسعار محددة بدون ضريبة القيمة المضافة ما لم ينص على خلاف ذلك.' },
      { num: '4.8', text: 'يعوض العميل النفقات المعقولة المتعلقة بتحصيل الديون.' }
    ]
  },
  
  obligations: {
    title: '5. حقوق والتزامات الأطراف',
    content: [
      { num: '5.1', text: 'يلتزم العميل بتقديم معلومات موثوقة وضمان الوصول والتفاعل اللازم.' },
      { num: '5.2', text: 'يؤدي مقدم الخدمة الخدمات بعناية مهنية ويُبلغ العميل بتقدم العمل.' },
      { num: '5.3', text: 'العميل مسؤول عن امتثال أنشطته للتشريعات (بما في ذلك اللائحة العامة لحماية البيانات وقانون العمل والضرائب).' },
      { num: '5.4', text: 'يحق لمقدم الخدمة إشراك مقاولين من الباطن، مع بقائه مسؤولاً عن النتيجة.' },
      { num: '5.5', text: 'لا يتحمل مقدم الخدمة المسؤولية عن عدم أداء الخدمات إذا لم يقدم العميل البيانات أو الوصول اللازم.' },
      { num: '5.6', text: 'إذا كانت الخدمات تستخدم منصات أو واجهات برمجة تطبيقات خارجية (مثل خدمات الذكاء الاصطناعي)، فإن العميل مسؤول عن الدفع والاستخدام القانوني. لا يتحمل مقدم الخدمة المسؤولية عن الأعطال أو عدم التوفر أو تغييرات الأسعار لهذه الخدمات.' }
    ]
  },
  
  ip: {
    title: '6. الملكية الفكرية',
    content: [
      { num: '6.1', text: 'تظل جميع المواد التي طورها مقدم الخدمة (التقارير والنصوص البرمجية والقوالب وما إلى ذلك) ملكًا له حتى الدفع الكامل.' },
      { num: '6.2', text: 'بعد الدفع الكامل، يحصل العميل على ترخيص غير حصري ودائم وغير قابل للنقل للاستخدام الداخلي للمواد. النقل إلى أطراف ثالثة والترخيص الفرعي محظور.' },
      { num: '6.3', text: 'يحق لمقدم الخدمة استخدام أمثلة مجهولة الهوية أو معممة (دراسات الحالة) في محفظته ومواده التسويقية. يمكن للعميل إرسال اعتراض كتابي عبر البريد الإلكتروني.' },
      { num: '6.4', text: 'لا يحق للعميل تعديل المواد أو فك تشفيرها أو استخدامها لتقديم خدمات مماثلة لأطراف ثالثة.' },
      { num: '6.5', text: 'تبقى جميع حقوق الملكية الفكرية غير المنقولة صراحةً لمقدم الخدمة.' }
    ]
  },
  
  confidentiality: {
    title: '7. السرية ومعالجة البيانات',
    content: [
      { num: '7.1', text: 'تتعهد الأطراف بعدم الكشف عن المعلومات السرية، باستثناء ما ينص عليه القانون.' },
      { num: '7.2', text: 'يظل التزام السرية ساري المفعول لمدة 3 سنوات بعد اكتمال الخدمات.' },
      { num: '7.3', text: 'يحق لمقدم الخدمة الكشف عن المعلومات لمستشاريه ومقاوليه بشرط التزامهم بالسرية.' },
      { num: '7.4', text: 'عند معالجة البيانات الشخصية للعميل، يعمل مقدم الخدمة كمعالج بيانات وفقًا للائحة العامة لحماية البيانات وقانون حماية البيانات الشخصية. في مثل هذه الحالات، تبرم الأطراف اتفاقية معالجة بيانات منفصلة (DPA).' },
      { num: '7.5', text: 'العميل مسؤول عن قانونية نقل البيانات الشخصية ويعوض الأضرار إذا كان نقلها أو معالجتها غير قانوني.' },
      { num: '7.6', text: 'يطبق مقدم الخدمة تدابير أمنية تقنية وتنظيمية معقولة ولكنه غير مسؤول عن الحوادث الناجمة عن البنية التحتية للعميل أو أطراف ثالثة.' }
    ]
  },
  
  liability: {
    title: '8. المدفوعات والاسترداد والمسؤولية',
    isHighRisk: true,
    content: [
      { num: '8.1', text: 'جميع المدفوعات غير قابلة للاسترداد، باستثناء الحالات التي لم يبدأ فيها مقدم الخدمة تقديم الخدمات خلال 30 يومًا دون سبب وجيه أو ارتكب انتهاكًا جوهريًا لم يتم تصحيحه خلال 15 يومًا بعد إخطار العميل.' },
      { num: '8.2', text: 'الدفع مقابل الخدمات يعني موافقة العميل الكاملة على هذه الشروط. بعد بدء تقديم الخدمات، لا يُسمح بالاستردادات وإعادة الحساب.' },
      { num: '8.3', text: 'في حالة الإنهاء الأحادي الجانب للمشروع من قبل العميل، يحق لمقدم الخدمة الاحتفاظ بجميع المدفوعات المستلمة.' },
      { num: '8.4', text: 'يحق لمقدم الخدمة تعليق أو إنهاء تقديم الخدمات في حالة انتهاك شروط الدفع أو شروط العقد.' },
      { num: '8.5', text: 'لا يتحمل مقدم الخدمة المسؤولية عن الخسائر غير المباشرة أو الأرباح الضائعة أو فقدان البيانات أو الخسائر المتعلقة بالسمعة.' },
      { num: '8.6', text: 'قد تنشأ مسؤولية مقدم الخدمة فقط في حالة القصد أو الإهمال الجسيم.' },
      { num: '8.7', text: 'تقتصر المسؤولية الإجمالية لمقدم الخدمة على 1000 يورو، بغض النظر عن أساس المطالبة.', amount: '€ 1 000' },
      { num: '8.8', text: 'يؤكد العميل أنه لن يقدم مطالبات بناءً على التوقعات أو التقييم الذاتي للنتائج.' },
      { num: '8.9', text: 'يعوض العميل مقدم الخدمة عن أي مطالبات أو خسائر أو عقوبات ناجمة عن الاستخدام غير القانوني لبيانات العميل أو موا ده.' }
    ]
  },
  
  termination: {
    title: '9. مدة السريان والإنهاء والعواقب',
    content: [
      { num: '9.1', text: 'يسري العقد من لحظة التوقيع أو دفع الفاتورة حتى اكتمال الخدمات.' },
      { num: '9.2', text: 'يجوز لكل طرف إنهاء العقد من خلال إخطار الطرف الآخر قبل 30 يومًا إذا انتهك الطرف الآخر الالتزامات الجوهرية ولم يعالج الانتهاك خلال 15 يومًا.' },
      { num: '9.3', text: 'بعد دفع الفاتورة، لا تُقبل أي استردادات أو إلغاءات، باستثناء ما هو منصوص عليه في البند 8.1.' },
      { num: '9.4', text: 'عند الإنهاء، تخضع جميع المبالغ غير المدفوعة للدفع الفوري.' },
      { num: '9.5', text: 'يحق لمقدم الخدمة إنهاء العقد فورًا إذا تأخر الدفع لأكثر من 15 يومًا.' },
      { num: '9.6', text: 'تظل الأحكام §§ 3.3–3.4، 4، 6، 7، 8، 9.6، 10–12 سارية المفعول بعد إنهاء العقد.' }
    ]
  },
  
  forceMajeure: {
    title: '10. القوة القاهرة',
    content: [
      { num: '10.1', text: 'تُعفى الأطراف من المسؤولية عن عدم تنفيذ الالتزامات بسبب القوة القاهرة (الكوارث الطبيعية والحروب والهجمات الإلكترونية وإخفاقات مزودي الذكاء الاصطناعي والعقوبات وانقطاع التيار الكهربائي وما إلى ذلك).' },
      { num: '10.2', text: 'يجب على الطرف المتأثر بالقوة القاهرة إخطار الطرف الآخر دون تأخير.' },
      { num: '10.3', text: 'إذا استمرت القوة القاهرة لأكثر من 60 يومًا، يجوز لأي طرف إنهاء العقد كتابيًا.' }
    ]
  },
  
  disputes: {
    title: '11. حل النزاعات والقانون المطبق',
    content: [
      { num: '11.1', text: 'تُحل النزاعات من خلال المفاوضات.' },
      { num: '11.2', text: 'في حالة عدم التوصل إلى اتفاق، يخضع النزاع للنظر في محكمة هارجو المحلية (Harju Maakohus)، إستونيا.' },
      { num: '11.3', text: 'يخضع العقد وهذه الشروط لقانون جمهورية إستونيا. لا تنطبق اتفاقية الأمم المتحدة بشأن عقود البيع الدولي للبضائع (CISG).' }
    ]
  },
  
  other: {
    title: '12. أحكام أخرى',
    content: [
      { num: '12.1', text: 'لا يحق للعميل نقل الحقوق والالتزامات بموجب العقد دون موافقة كتابية من مقدم الخدمة.' },
      { num: '12.2', text: 'التنازل عن حكم واحد لا يعني التنازل عن الأحكام الأخرى.' },
      { num: '12.3', text: 'بطلان بند فردي لا يؤثر على صحة الأحكام الأخرى.' },
      { num: '12.4', text: 'التوقيعات الإلكترونية والمسح الضوئي (بما في ذلك التوقيع الإلكتروني) معادلة للتوقيعات المكتوبة بخط اليد.' },
      { num: '12.5', text: 'تعتبر الإخطارات المرسلة عبر البريد الإلكتروني مستلمة في يوم العمل التالي.' },
      { num: '12.6', text: 'تؤكد الأطراف الامتثال لتشريعات العقوبات والتصدير ومكافحة غسل الأموال.' },
      { num: '12.7', text: 'يتعهد العميل بعدم توظيف موظفي أو مقاولي مقدم الخدمة خلال 6 أشهر بعد اكتمال الخدمات؛ غرامة - 10,000 يورو.', penalty: '€ 10 000' },
      { num: '12.8', text: 'مقدم الخدمة ليس شركة قانونية أو مالية؛ جميع الاستشارات ذات طبيعة معلوماتية وتحليلية ولا تشكل مشورة قانونية أو استثمارية.' }
    ]
  },
  
  importantNotice: 'بتوقيع الاتفاقية أو دفع الفاتورة، يؤكد العميل أنه قد قرأ وفهم وقبل هذه الشروط بالكامل. تنطبق هذه الشروط فقط على معاملات B2B بين الكيانات القانونية و/أو أصحاب المشاريع الفردية.'
};
